import { getSessionToken } from "@shopify/app-bridge/utilities";
import axios from "axios";
import { EmbeddedApp } from "../App";
import config, { BACKEND_URL } from "../config";
import { showConversation } from "@intercom/messenger-js-sdk";

export const postData = async ({
    payload = {},
    url = "",
    skipErrorMsg = false,
    signal = undefined,
}: {
    payload?: any;
    url?: string;
    skipErrorMsg?: boolean;
    signal?: AbortSignal;
}) => {
    let res;
    try {
        const a = await getSessionToken(EmbeddedApp).catch();

        res = await axios.post(`${BACKEND_URL}${url}`, payload, {
            headers: {
                Authorization: "Bearer " + a,
                "ngrok-skip-browser-warning": "raman",
            },
            signal,
            skipErrorMsg: skipErrorMsg,
        } as any);
    } catch (error: any) {
        if (error.name === "AbortError" || axios.isCancel(error)) {
            throw new DOMException("Request cancelled", "AbortError");
        }
        return error.response || { data: {} };
    }
    return res;
};

export const getData = async ({
    url = "",
    params = {},
    skipErrorMsg = false,
    signal = undefined,
}: {
    url?: string;
    params?: Record<string, any>;
    skipErrorMsg?: boolean;
    signal?: AbortSignal;
}) => {
    let res;
    try {
        const a = await getSessionToken(EmbeddedApp).catch();
        res = await axios.get(`${BACKEND_URL}${url}`, {
            headers: {
                Authorization: "Bearer " + a,
                "ngrok-skip-browser-warning": "raman",
            },
            signal,
            skipErrorMsg: skipErrorMsg,
            params,
        } as any);
    } catch (error: any) {
        if (error.name === "AbortError" || axios.isCancel(error)) {
            throw new DOMException("Request cancelled", "AbortError");
        }
        return error.response || { data: {} };
    }
    return res;
};

export const initiateIntercomChat = async (message = "") => {
    if (!message) {
        return;
    }
    const res = await postData({
        url: endPoints.createConversation,
        payload: { message: message },
    });
    if (res.status == 200) {
        showConversation(res.data.InterComConversations);
    }
};

export async function sendAutomatedMessage(message: string = "") {
    if (!message) {
        return;
    }
    await postData({
        url: endPoints.sendAutomatedMessage,
        payload: {
            user_custom_id: shopify.config.shop,
            content: message,
        },
    });
    window.userengage("widget.open");
}

export const endPoints = {
    get getAllBars() {
        return "/" + config.appName + "/common-bar/get-all-bar";
    },
    // FSB Starts
    get fsBarSave() {
        return "/" + config.appName + "/shipping-bar/save-bar";
    },
    get fsBarUpdate() {
        return "/" + config.appName + "/shipping-bar/update-bar";
    },
    get fsBarGet() {
        return "/" + config.appName + "/shipping-bar/get-bar-by-id?form_id=";
    },
    get fsBarStatusUpdate() {
        return "/" + config.appName + "/shipping-bar/update-bar-status";
    },
    get fsGetTemplates() {
        return "/" + config.appName + "/shipping-bar/get-all-template";
    },
    get fsSaveTemplate() {
        return "/" + config.appName + "/shipping-bar/update-template";
    },
    // FSB Ends
    // ACB Starts

    get acBarGet() {
        return "/" + config.appName + "/announcement-bar/get-bar-by-id?form_id=";
    },
    get acBarSave() {
        return "/" + config.appName + "/announcement-bar/save-bar";
    },
    get acBarUpdate() {
        return "/" + config.appName + "/announcement-bar/update-bar";
    },
    get acBarStatusUpdate() {
        return "/" + config.appName + "/announcement-bar/update-bar-status";
    },
    get acGetTemplates() {
        return "/" + config.appName + "/announcement-bar/get-all-template";
    },
    get acSaveTemplate() {
        return "/" + config.appName + "/announcement-bar/update-template";
    },
    // ACB Ends
    // CDB Starts

    get cdBarSave() {
        return "/" + config.appName + "/countdown-bar/save-bar";
    },
    get cdBarUpdate() {
        return "/" + config.appName + "/countdown-bar/update-bar";
    },
    get cdBarGet() {
        return "/" + config.appName + "/countdown-bar/get-bar-by-id?form_id=";
    },
    get cdBarStatusUpdate() {
        return "/" + config.appName + "/countdown-bar/update-bar-status";
    },
    get cdGetTemplates() {
        return "/" + config.appName + "/countdown-bar/get-all-template";
    },
    get cdSaveTemplate() {
        return "/" + config.appName + "/countdown-bar/update-template";
    },
    // CDB Ends

    // ECB Starts
    get ecBarSave() {
        return "/" + config.appName + "/email-collection-bar/save-bar";
    },

    get ecBarUpdate() {
        return "/" + config.appName + "/email-collection-bar/update-bar";
    },
    get ecEmailSave() {
        return "/" + config.appName + "/email-collection-bar/save-email";
    },
    get ecGetEmailsList() {
        return "/" + config.appName + "/email-collection-bar/get-all-emails";
    },
    get ecBarGet() {
        return "/" + config.appName + "/email-collection-bar/get-bar-by-id?form_id=";
    },
    get ecBarStatusUpdate() {
        return "/" + config.appName + "/email-collection-bar/update-bar-status";
    },
    get ecGetTemplates() {
        return "/" + config.appName + "/email-collection-bar/get-all-template";
    },
    get ecSaveTemplate() {
        return "/" + config.appName + "/email-collection-bar/update-template";
    },

    get ecSyncPrevEmails() {
        return "/" + config.appName + "/email-collection-bar/sync-previous-emails";
    },

    // ECB Ends

    //app level
    get extensionStatus() {
        return "/" + config.appName + "/extension-status";
    },
    get updateOnboardingStatus() {
        return "/" + config.appName + "/update-onboarding";
    },
    // Integrations
    get integrationsStatus() {
        return "/" + config.appName + "/integrations/email/connection-status";
    },
    get getKlaviyoList() {
        return "/" + config.appName + "/integrations/email/get-lists";
    },
    get integrationConnect() {
        return "/" + config.appName + "/integrations/email/connect-integration";
    },

    get syncPrevEmails() {
        return "/" + config.appName + "/integrations/email/sync-previous-emails";
    },

    get updateListOnServer() {
        return "/" + config.appName + "/integrations/email/update-list";
    },

    get integrationDisconnect() {
        return "/" + config.appName + "/integrations/email/disconnect-integration";
    },

    get shopifySyncEmails() {
        return "/" + config.appName + "/email-collection-bar/sync-shopify-emails";
    },

    get saveFeedback() {
        return "/" + config.appName + "/common-bar/save-feedback";
    },

    // Bundles APIs
    get saveBundle() {
        return "/" + config.appName + "/bundles/save-bundle";
    },
    get updateBundle() {
        return "/" + config.appName + "/bundles/update-bundle";
    },
    get getBundle() {
        return "/" + config.appName + "/bundles/get-bundle-by-id?form_id=";
    },
    get getAllBundles() {
        return "/" + config.appName + "/bundles/get-all-bundles";
    },
    get getBundleDesignsByType() {
        return "/" + config.appName + "/bundles/get-bundle-designs";
    },
    get getHomepageDetails() {
        return "/" + config.appName + "/bundles/home-pages-details";
    },
    get updateBundleStatus() {
        return "/" + config.appName + "/bundles/update-bundle-status";
    },
    get getBundlesSettings() {
        return "/" + config.appName + "/bundles/get-bundles-global-settings";
    },
    get updateBundleSettings() {
        return "/" + config.appName + "/bundles/update-bundle-global-settings";
    },
    get updateSwatchesMeta() {
        return "/" + config.appName + "/bundles/swatches-meta-update";
    },
    get getBundleStats() {
        return "/" + config.appName + "/bundles/get-clicks-views";
    },
    get listAbTests() {
        return "/" + config.appName + "/bundles/ab-test/list";
    },
    get markAbTestWinner() {
        return "/" + config.appName + "/bundles/ab-test/mark-winner";
    },
    get startOverAbTest() {
        return "/" + config.appName + "/bundles/ab-test/start-over";
    },
    get getAllPlans() {
        return "/" + config.appName + "/bundles/get-plans";
    },
    get getCurrentPlan() {
        return "/" + config.appName + "/bundles/get-current-plan";
    },
    get createSubscription() {
        return "/" + config.appName + "/bundles/create-subscription";
    },
    get verifyDiscountCode() {
        return "/" + config.appName + "/bundles/coupon-code-check";
    },
    get cancelSubscription() {
        return "/" + config.appName + "/bundles/cancel-subscription";
    },
    get suggestFeature() {
        return "/" + config.appName + "/bundles/suggest-feature";
    },
    get productHasSubscriptions() {
        return "/" + config.appName + "/bundles/product-has-subscriptions";
    },
    get getPostPurchaseData() {
        return "/" + config.appName + "/post-purchase/get-post-purchase?post-purchase-id=";
    },
    get savePostPurchase() {
        return "/" + config.appName + "/post-purchase/save-post-purchase";
    },
    get updatePostPurchase() {
        return "/" + config.appName + "/post-purchase/update-post-purchase";
    },
    get checkPostPurchaseExtension() {
        return "/" + config.appName + "/post-purchase/check-extension-status";
    },
    get getAllPostPurchases() {
        return "/" + config.appName + "/post-purchase/get-all-post-purchase";
    },
    get deletePostPurchase() {
        return "/" + config.appName + "/post-purchase/delete-post-purchase";
    },
    get getPostPurchaseCommonDesign() {
        return "/" + config.appName + "/post-purchase/get-page-customization";
    },

    get saveCartConfig() {
        return "/" + config.appName + "/bundles/cart/save-cart";
    },
    get getCartConfig() {
        return "/" + config.appName + "/bundles/cart/get-cart";
    },

    get updateCartConfig() {
        return "/" + config.appName + "/bundles/cart/update-cart";
    },

    get createAiBundles() {
        return "/" + config.appName + "/bundles/ai-suggestions-create";
    },
    get aiBundlesCreationStatus() {
        return "/" + config.appName + "/bundles/ai-suggestions-api-status";
    },
    get publishAiBundles() {
        return "/" + config.appName + "/bundles/publish-all-ai-bundles";
    },
    get deleteAiBundles() {
        return "/" + config.appName + "/bundles/delete-all-ai-bundles";
    },
    get getThankYouPageData() {
        return "/" + config.appName + "/thank-you-page/get-thankyou-page-data?upsell_id=";
    },
    get saveThankYouPage() {
        return "/" + config.appName + "/thank-you-page/save-thankyou-page";
    },
    get updateThankYouPage() {
        return "/" + config.appName + "/thank-you-page/update-thankyou-page";
    },
    get getProfileId() {
        return "/" + config.appName + "/thank-you-page/get-profile-id";
    },
    // get checkThankYouPageExtension() {
    //     return "/" + config.appName + "/thank-you-page/check-extension-status";
    // },
    get getAllThankYouPages() {
        return "/" + config.appName + "/thank-you-page/get-all-thankyou-page-data";
    },
    get deleteThankYouPage() {
        return "/" + config.appName + "/thank-you-page/delete-thankyou-page-data";
    },

    // save feedback
    get blank() {
        return "/";
    },

    // intercom
    get createConversation() {
        return "/" + config.appName + "/bundles/conversations";
    },

    get getfiles() {
        return "/" + config.appName + "/bundles/get-files";
    },
    get filesOperation() {
        return "/" + config.appName + "/bundles/files-operation";
    },
    get getOnboardingData() {
        return "/" + config.appName + "/bundles/get-all-bundles-count";
    },

    get sendAutomatedMessage() {
        return "/" + config.appName + "/bundles/sendMessageAsUser";
    },

    // Analytics APIs
    get checkEmptyState() {
        return "/" + config.appName + "/bundles/analytics/check-empty-state";
    },

    // Summary tab
    get summaryKpis() {
        return "/" + config.appName + "/bundles/analytics/summary/kpis";
    },
    get revenueOverTime() {
        return "/" + config.appName + "/bundles/analytics/summary/revenue-over-time";
    },
    get summaryPerformance() {
        return "/" + config.appName + "/bundles/analytics/summary/performance";
    },

    // Bundles tab
    get bundlesKpis() {
        return "/" + config.appName + "/bundles/analytics/bundles/kpis";
    },
    get topBundles() {
        return "/" + config.appName + "/bundles/analytics/bundles/top-bundles";
    },
    get bundlesRevenueOverTime() {
        return "/" + config.appName + "/bundles/analytics/bundles/revenue-over-time";
    },
    get bundlesFunnel() {
        return "/" + config.appName + "/bundles/analytics/bundles/funnel";
    },

    // Slide cart tab
    get slideCartKpis() {
        return "/" + config.appName + "/bundles/analytics/slide-cart/kpis";
    },
    get topSlideCartProducts() {
        return "/" + config.appName + "/bundles/analytics/slide-cart/top-products";
    },
    get slideCartRevenueOverTime() {
        return "/" + config.appName + "/bundles/analytics/slide-cart/revenue-over-time";
    },

    // Post-purchase tab
    get postPurchaseKpis() {
        return "/" + config.appName + "/bundles/analytics/post-purchase/kpis";
    },
    get postPurchaseRevenueOverTime() {
        return "/" + config.appName + "/bundles/analytics/post-purchase/revenue-over-time";
    },
    get topPostPurchaseProducts() {
        return "/" + config.appName + "/bundles/analytics/post-purchase/top-products";
    },
    get postPurchasePerformance() {
        return "/" + config.appName + "/bundles/analytics/post-purchase/performance";
    },

    // Thank you page tab
    get thankYouKpis() {
        return "/" + config.appName + "/bundles/analytics/thank-you/kpis";
    },
    get thankYouRevenueOverTime() {
        return "/" + config.appName + "/bundles/analytics/thank-you/revenue-over-time";
    },
    get topThankYouProducts() {
        return "/" + config.appName + "/bundles/analytics/thank-you/top-products";
    },
    get thankYouPerformance() {
        return "/" + config.appName + "/bundles/analytics/thank-you/performance";
    },

    get syncOffers() {
        return "/" + config.appName + "/bundles/sync-all-bundles";
    },
    get executeGraphql() {
        return "/" + config.appName + "/bundles/executeGraphql";
    },

    // NPS APIs
    get npsStatus() {
        return "/" + config.appName + "/bundles/nps/status";
    },
    get npsSaveRating() {
        return "/" + config.appName + "/bundles/nps/rating";
    },
    get npsSaveFeedback() {
        return "/" + config.appName + "/bundles/nps/feedback";
    },
    get npsCompleteRatingFive() {
        return "/" + config.appName + "/bundles/nps/complete-rating-five";
    },
    get npsDismiss() {
        return "/" + config.appName + "/bundles/nps/dismiss";
    },

    // Kefi Labs early access
    get labsEarlyAccess() {
        return "/" + config.appName + "/labs/early-access";
    },

    // Post show on store modal slack message
    get sendShowOnStoreFeedback() {
        return "/" + config.appName + "/bundles/send-show-on-store-feedback";
    },

    // Translations APIs
    get getLocales() {
        return "/" + config.appName + "/translations/locales";
    },
    get getStrings() {
        return "/" + config.appName + "/translations/strings";
    },
    get getTranslationsData() {
        return "/" + config.appName + "/translations/data";
    },
    get saveTranslations() {
        return "/" + config.appName + "/translations/save";
    },
    get aiTranslate() {
        return "/" + config.appName + "/translations/ai-translate";
    },
};
